import { render, staticRenderFns } from "./TitleDetailAccordion.vue?vue&type=template&id=1d2bb342&scoped=true"
import script from "./TitleDetailAccordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleDetailAccordion.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleDetailAccordion.vue?vue&type=style&index=0&id=1d2bb342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2bb342",
  null
  
)

export default component.exports